import { render, staticRenderFns } from "./InputTableSettings.vue?vue&type=template&id=18a1126f"
import script from "./InputTableSettings.vue?vue&type=script&lang=ts"
export * from "./InputTableSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports